import {
    KEYCLOAK_LOGIN_USER,
    KEYCLOAK_LOGIN_USER_SUCCESS,
    KEYCLOAK_LOGIN_USER_ERROR,
    KEYCLOAK_LOGOUT_USER
} from '../actions';

const INIT_STATE = {
    user: localStorage.getItem('keycloak_user_token'),
    data: null,
    error: ''
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case KEYCLOAK_LOGIN_USER:
            return { ...state, loading: true, data: null, error: '' };
        case KEYCLOAK_LOGIN_USER_SUCCESS:
            return { ...state, loading: false, user: action.payload.user.key, data: action.payload.user, error: '' };
        case KEYCLOAK_LOGIN_USER_ERROR:
            return { ...state, loading: false, user: '', data: null, error: action.payload.message };
        case KEYCLOAK_LOGOUT_USER:
            return { ...state, user: '', data: null, error: '' };
        default: return { ...state };
    }
}
